module.exports = __webpack_public_path__ + "static/media/8.caf57578.png";